'use client';

import React from 'react';

interface Step {
  step: string;
  icon: string;
  title: string;
  description: string;
}

interface ProcessSectionProps {
  title: string;
  subtitle: string;
  steps: Step[];
}

export default function ProcessSection({ title, subtitle, steps }: ProcessSectionProps) {
  return (
    <section id="craft" className="py-32 max-w-7xl mx-auto px-8 md:px-16">
      <div className="text-center mb-20">
        <h2 data-reveal className="text-5xl md:text-6xl font-black mb-4"
          style={{ fontFamily: "'Playfair Display', serif" }}>
          {title}
        </h2>
        <p data-reveal className="opacity-50 max-w-md mx-auto">{subtitle}</p>
      </div>

      <div data-reveal data-stagger className="grid md:grid-cols-4 gap-8">
        {steps.map((step, idx) => (
          <div key={idx} className="relative group">
            {idx < steps.length - 1 && (
              <div className="hidden md:block absolute top-10 left-full w-full h-px z-0"
                style={{ background: "linear-gradient(90deg, rgba(200,135,42,.3), transparent)" }} />
            )}
            <div className="relative z-10 p-8 rounded-2xl text-center group-hover:-translate-y-2 transition-transform duration-500"
              style={{ background: "linear-gradient(135deg, var(--roast), var(--smoke))", border: "1px solid rgba(200,135,42,.1)" }}>
              <div className="text-xs tracking-widest mb-4 opacity-30">{step.step}</div>
              <div className="text-4xl mb-4">{step.icon}</div>
              <h3 className="text-xl font-bold mb-3" style={{ fontFamily: "'Playfair Display', serif", color: "var(--gold)" }}>
                {step.title}
              </h3>
              <p className="text-sm leading-relaxed opacity-50">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}